import React, { useCallback, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { faSpa } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import ClipLoader from 'react-spinners/ClipLoader'
import { type LoginRequestData } from '../types/auth'
import { useLoginUserMutation } from '../store/api/authApi'
import { isEmailValid } from '../utils'

export function LoginPage(): JSX.Element {
  const navigate = useNavigate()
  const [loginUser] = useLoginUserMutation()

  const [email, setEmail] = useState<string>('')
  const [password, setPassword] = useState<string>('')
  const [isApiRequestInProgress, setIsApiRequestInProgress] = useState<boolean>(false)

  const isFormValid = useMemo(() => {
    return isEmailValid(email) && password
  }, [email, password])

  const onLoginClicked = useCallback(async () => {
    const request: LoginRequestData = {
      email,
      password,
    }

    try {
      setIsApiRequestInProgress(true)
      const loginRes = await loginUser({ data: request }).unwrap()
      console.dir(loginRes)
      setIsApiRequestInProgress(false)
      toast('Successfully logged in')

      const roles = loginRes && loginRes.dto && loginRes.dto.roles ? loginRes.dto.roles : []

      navigate(roles.includes('ROLE_FUNDER') ? '/dashboard' : '/grants')
    } catch (e) {
      console.error(e)
      toast.error('Failed to login')
      setIsApiRequestInProgress(false)
    }
  }, [email, password, loginUser])

  return (
    <main className="main" id="top">
      <div className="container">
        <div className="row flex-center min-vh-100 py-5">
          <div className="d-flex flex-column col-sm-10 col-md-8 col-lg-5 col-xl-5 col-xxl-3">
            <button
              type="button"
              className="btn-link d-flex flex-center text-decoration-none mb-4"
              onClick={() => navigate('/')}
            >
              <div className="d-flex align-items-center fw-bolder fs-5 d-inline-block">
                <FontAwesomeIcon
                  icon={faSpa}
                  className="text-warning-300 fs-5"
                  style={{ width: '60px', height: '60px' }}
                />
              </div>
            </button>
            <div className="text-center mb-7">
              <h3 className="text-1000">Sign In</h3>
              <p className="text-700">Get access to your account</p>
            </div>
            <div className="mb-3 text-start">
              <label className="form-label" htmlFor="email">
                Email address
              </label>
              <div className="form-icon-container">
                <input
                  type="email"
                  className="form-control form-icon-input"
                  id="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                  }}
                  placeholder="name@example.com"
                />
                <span className="fas fa-user text-900 fs--1 form-icon"></span>
              </div>
            </div>
            <div className="mb-3 text-start mb-7">
              <label className="form-label" htmlFor="password">
                Password
              </label>
              <div className="form-icon-container">
                <input
                  type="password"
                  className="form-control form-icon-input"
                  id="password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value)
                  }}
                  placeholder="Password"
                />
                <span className="fas fa-key text-900 fs--1 form-icon"></span>
              </div>
            </div>
            {/*
              <div className="row flex-between-center mb-7">
                <div className="col-auto">
                  <a className="fs--1 fw-semi-bold" href="#">
                    Forgot Password?
                  </a>
                </div>
              </div>
              */}

            <button
              type="button"
              className="btn btn-primary w-100 mb-3"
              disabled={!isFormValid}
              onClick={onLoginClicked}
            >
              {isApiRequestInProgress ? (
                <ClipLoader color="white" loading={isApiRequestInProgress} size={15} />
              ) : (
                'Sign in'
              )}
            </button>
            <div className="text-center">
              <a className="fs--1 fw-bold pointer" onClick={() => navigate('/register')}>
                Create an account
              </a>
            </div>
          </div>
        </div>
      </div>
    </main>
  )
}
